module.exports = __webpack_public_path__ + "static/img/img-about-7.26e70e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-about-7.png
// module id = 6D8z
// module chunks = 0